<template>
  <div class="page-learn-ability-test-result-page">
    <result-header type="end"
    />
    <img class="page-learn-ability-test-result-page-report-img"
         :src="require('@/pages/2020/LearnAbilityTest/assets/img/result_report.png')"
    />
    <div class="page-learn-ability-test-result-page-content">
      已为您生成专属<br/>
      <span>「自主学习力测评报告」</span><br/>
      （可了解孩子在学习过程中的优势与不足）
    </div>
    <div class="page-learn-ability-test-result-page-share-btn"
         @click="handleSharePage"
         v-ym-report:MARKETING_LEARNABILITYTEST_RESULT_CLICK=""
    >
      <span>查看报告</span>
      分享本测试给好友即可获得
    </div>

    <share-hint :show.sync="showShareHint"></share-hint>
  </div>
</template>

<script>
  import ShareHint from '@/pages/2020/LearnAbilityTest/components/ShareHint';
  import Header from '@/pages/2020/LearnAbilityTest/components/Header';

  export default {
    name: 'LearnAbilityTestResultPage',
    components: {
      'result-header': Header,
      ShareHint,
    },
    data() {
      return {
        showShareHint: false,
      };
    },
    methods: {
      handleSharePage() {
        this.showShareHint = true;
        this.$emit('show-share-hint');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-learn-ability-test-result-page {
    height: 100%;
    background: #242648;

    &-report-img {
      margin: 0 auto;
      display: block;
      width: 588px;
      height: 470px;
    }
    &-content {
      margin-bottom: 65px;
      color: @color-white;
      font-size: 30px;
      text-align: center;
      line-height: 1.6;
      span {
        color: #ffeb63;
        font-size: 36px;
        font-weight: bold;
      }
    }
    &-share-btn {
      margin: 0 auto;
      width: 456px;
      height: 120px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #987f51;
      font-size: 26px;
      border-radius: 60px;
      background: linear-gradient(0deg, #FFDF30, #FFF176);
      box-shadow: 0 8px 12px 0 rgba(16, 18, 53, 0.4);
      span {
        color: #242648;
        font-size: 36px;
        font-weight: bold;
      }
    }
  }

</style>
